'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var trigger = exports.trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};


//////////////////
// WEBPACK FOOTER
// ./~/v-mask/dist/utils/index.js
// module id = 247
// module chunks = 0